import { useState } from 'react';
import { BaseFieldProps, SearchField } from '@frontend/design-system';
import { useInterval } from '@frontend/design-system';
import { SearchableElements } from '../constants';
import { StyleConfig } from '../global-search-main';

interface RotatingSearchFieldProps {
  searchFieldProps: BaseFieldProps<string, '', HTMLInputElement>;
  styleConfig: StyleConfig;
  isOpen: boolean;
  dataTrackingid: string;
  onSearchSubmit: () => void;
}

export const RotatingSearchField = ({
  searchFieldProps,
  styleConfig,
  isOpen,
  dataTrackingid,
  onSearchSubmit,
}: RotatingSearchFieldProps) => {
  const [rotatingIndex, setRotatingIndex] = useState(0);
  const totalElements = SearchableElements.length;
  const shouldRotate = !isOpen && rotatingIndex < totalElements - 1;

  useInterval(
    () => {
      setRotatingIndex((prev) => prev + 1);
    },
    5000,
    shouldRotate
  );

  return (
    <SearchField
      {...searchFieldProps}
      name='Global Search'
      data-trackingid={dataTrackingid}
      onSearchSubmit={onSearchSubmit}
      placeholder={`Search ${SearchableElements[rotatingIndex]}`}
      clearable={false}
      readOnly
      css={styleConfig.searchFieldCss(isOpen)}
      containerCss={styleConfig.searchFieldContainerCss(isOpen)}
    />
  );
};
